import styled from "styled-components";

const VideoListJackpotValueDefaultBox = styled.span`
  color: ${({theme}) => theme.colors.brandPrimary.toString()};
  margin-left: 0.5rem;
`;

export const VideoListJackpotValueBox = VideoListJackpotValueDefaultBox;
